<i18n>
{
  "en": {
      "title": "Frequency Response of displacement",
      "subTitle": "Graph relating to the FFT (Fast Fourier Transform) algorithm of the selected event. This algorithm is used to calculate Frequency Response faster. It allows to highlight the spectral content of the signals coming from the sensors. It is therefore possible to visualize the frequency response of the oscillations and it is possible to obtain the characteristics and information of the signal, not perceptible in the time domain."

  },
  "it": {
      "title": "Frequency Response dello spostamente",
      "subTitle": "Grafico relativo all’algoritmo FFT (Fast Fourier Transform) dell’evento selezionato. Questo algoritmo, utilizzato per calcolare più velocemente la Frequency Response, permette di evidenziare il contenuto spettrale dei segnali provenienti dai sensori. Risulta quindi possibile visualizzare il Frequency Response delle oscillazioni (mm) grazie alla quale è possibile ricavare le caratteristiche e le informazioni del segnale, non percettibili nel dominio del tempo."
  }
}
</i18n>

<template>
  <BalloonTemplate arrowDirection="left" id="root" :visible="visible" @close="$emit('close')">
    <template v-slot:header>
      <h1>{{ $t("title") }}</h1>
    </template>
    <template v-slot:content>
      <p>{{ $t("subTitle") }}</p>
    </template>
  </BalloonTemplate>
</template>
<script>
import BalloonTemplate from "../../BallonTemplate.vue";

export default {
  name: "freqRespDeckBalloon",
  components: {
    BalloonTemplate,
  },
  props: {
    visible: Boolean,
  },
};
</script>
<style scoped>
#root {
  width: 420px;
}
</style>
